import axios from "./axios";

const config = {};

// -------------------------------------------------------
// Common config values should go here
// =======================================================
const common = {
  axios
};

// -------------------------------------------------------
// Local config
// =======================================================
const local = Object.assign({}, common, {
  api: {
    host: "https://dev.moydomonline.ru/api/"
  },
  site: {
    host: "https://dev.moydomonline.ru"
  }
});

// -------------------------------------------------------
// Development config
// =======================================================
const development = Object.assign({}, common, {
  api: {
    host: "https://dev.moydomonline.ru/api/"
  },
  site: {
    host: "https://dev.moydomonline.ru"
  }
});

// -------------------------------------------------------
// Production config
// =======================================================
const production = Object.assign({}, common, {
  api: {
    host: "https://moydomonline.ru/api/"
  },
  site: {
    host: "https://moydomonline.ru"
  }
});

/**
 * Returns the configuration based on domain
 * @returns {object}
 */
function getConfig() {
  if (!global.window) {
    return local;
  }

  if (process.env.NODE_ENV === "test") {
    return local;
  }

  switch (window.location.hostname) {
    case "localhost": // fallthrough
    case "127.0.0.1":
      return local;

    case "cabinet.dev.moydomonline.ru":
      return development;

    case "cabinet.moydomonline.ru":
      return production;

    default:
      throw new Error(`Unknown environment: ${window.location.hostname}`);
  }
}

Object.assign(config, getConfig());
Object.assign(config.axios, { baseURL: getConfig().api.host });

function getItem(key) {
  return key in config ? config[key] : null;
}

function setItem(key, value) {
  config[key] = value;
}

Object.assign(config, {
  getItem,
  setItem
});

export default config;
